import { NAT_MAP } from '@/pages/income/config';
import {
  DEVICE_ONLINE_TIME_INDICATOR,
  DEVICE_PING_LOST_INDICATOR,
  DEVICE_PING_RTT_INDICATOR,
} from '@/pages/income/config/device';

const getOnlineChartOption = options => {
  const defaultOption = {
    xAxis: {
      type: 'category',
      axisTick: {
        show: false,
        alignWithLabel: true,
      },
      axisLine: { show: false },
      axisLabel: {
        color: '#999999',
        showMaxLabel: true,
      },
      data: options.xData,
    },
    yAxis: {
      type: 'value',
      max: 1,
      min: 0,
      name: options.yTitle,
      nameTextStyle: {
        color: '#999999',
      },
      minInterval: 0.25,
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: {
        lineStyle: { color: '#ececec' },
      },
      axisLabel: {
        color: '#999999',
      },
    },
    series: [
      {
        data: options.yData,
        type: 'bar',
        itemStyle: {
          normal: {
            barBorderRadius: [10, 10, 0, 0],
            color: '#dbb378',
          },
        },
      },
    ],
    grid: {
      left: 33,
      top: 30,
      right: 10,
      bottom: 20,
    },
  };
  return defaultOption;
};

const getPingLostOption = options => {
  if (!options.yData && !options.xData) return {};
  const yLen = options.yData.length;
  const xLen = options.xData.length;
  const defaultOption = {
    visualMap: [
      {
        show: false,
        type: 'continuous',
        seriesIndex: 0,
        min: 0,
        max: 35,
        inRange: {
          color: ['#D4A764', '#ECD09A'],
        },
      },
    ],
    xAxis: {
      type: 'category',
      axisTick: {
        show: false,
        alignWithLabel: true,
      },
      splitNumber: 24,
      axisLine: { show: false },
      axisLabel: {
        color: '#999999',
        showMaxLabel: true,
        interval: xLen > 7 ? 'auto' : 0,
      },
      data: options.xData,
    },
    yAxis: {
      type: 'value',
      name: options.yTitle,
      nameTextStyle: {
        color: '#999999',
      },
      min: 0,
      // max: yLen > 0 ? 'dataMax' : 35,
      // minInterval: 0.05,
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: {
        lineStyle: { color: '#ececec' },
      },
      axisLabel: {
        color: '#999999',
        showMaxLabel: true,
      },
    },
    series: [
      {
        data: options.yData,
        type: 'line',
        symbol: 'none',
        markPoint: {
          silent: true,
          symbol: 'rect',
          symbolSize: [50, 20],
          symbolOffset: ['-15%', 5],
          label: {
            color: '#ffffff',
            align: 'center',
            verticalAlign: 'middle',
            formatter: `${options.yData[yLen - 1]}`,
          },
          itemStyle: {
            color: '#000000',
            opacity: 0.6,
          },
          data: [
            {
              name: '最大值',
              type: 'max',
              valueDim: 'x',
            },
          ],
        },
      },
    ],
    grid: {
      left: 38,
      top: 30,
      right: 15,
      bottom: 20,
    },
  };
  // 保证没有数据时也会有表格刻度线展示
  if (yLen === 0) defaultOption.yAxis.max = 35;
  return defaultOption;
};

// const getPingRttOption = options => {
//   if (!options.yData && !options.xData) return {};
//   const yLen = options.yData.length;
//   const xLen = options.xData.length;
//   const defaultOption = {
//     visualMap: [
//       {
//         show: false,
//         type: 'continuous',
//         seriesIndex: 0,
//         min: 0,
//         inRange: {
//           color: ['#D4A764', '#ECD09A'],
//         },
//       },
//     ],
//     xAxis: {
//       type: 'category',
//       axisTick: {
//         show: false,
//         alignWithLabel: true,
//       },
//       splitNumber: 24,
//       axisLine: { show: false },
//       axisLabel: {
//         color: '#999999',
//         showMaxLabel: true,
//         interval: xLen > 7 ? 'auto' : 0,
//       },
//       data: options.xData,
//     },
//     yAxis: {
//       type: 'value',
//       name: options.yTitle,
//       nameTextStyle: {
//         color: '#999999',
//       },
//       min: 0,
//       max: yLen > 0 ? 'dataMax' : 35,
//       // minInterval: 0.05,
//       axisLine: { show: false },
//       axisTick: { show: false },
//       splitLine: {
//         lineStyle: { color: '#ececec' },
//       },
//       axisLabel: {
//         color: '#999999',
//         showMaxLabel: true,
//       },
//     },
//     series: [
//       {
//         data: options.yData,
//         type: 'line',
//         symbol: 'none',
//         markPoint: {
//           silent: true,
//           symbol: 'rect',
//           symbolSize: [50, 20],
//           symbolOffset: ['-15%', 5],
//           label: {
//             color: '#ffffff',
//             align: 'center',
//             verticalAlign: 'middle',
//             formatter: `${options.yData[yLen - 1]}`,
//           },
//           itemStyle: {
//             color: '#000000',
//             opacity: 0.6,
//           },
//           data: [
//             {
//               name: '最大值',
//               type: 'max',
//               valueDim: 'x',
//             },
//           ],
//         },
//       },
//     ],
//     grid: {
//       left: 38,
//       top: 30,
//       right: 15,
//       bottom: 20,
//     },
//   };
//   return defaultOption;
// };

const getCpuOption = options => {
  const yLen = options.yData.length;
  const xLen = options.xData.length;
  const defaultOption = {
    visualMap: [
      {
        show: false,
        type: 'continuous',
        seriesIndex: 0,
        min: 0,
        max: 100,
        inRange: {
          color: ['#D4A764', '#ECD09A'],
        },
      },
    ],
    xAxis: {
      type: 'category',
      axisTick: {
        show: false,
        alignWithLabel: true,
      },
      axisLine: { show: false },
      axisLabel: {
        color: '#999999',
        showMaxLabel: true,
        interval: xLen > 7 ? 'auto' : 0,
      },
      data: options.xData,
    },
    yAxis: {
      type: 'value',
      name: options.yTitle,
      nameTextStyle: {
        color: '#999999',
      },
      max: yLen > 0 ? 'dataMax' : 100,
      min: 0,
      // minInterval: 25,
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: {
        lineStyle: { color: '#ececec' },
      },
      axisLabel: {
        color: '#999999',
        showMaxLabel: true,
      },
    },
    series: [
      {
        data: options.yData,
        type: 'line',
        symbol: 'none',
        markPoint: {
          silent: true,
          symbol: 'rect',
          symbolSize: [50, 20],
          symbolOffset: ['-15%', 0],
          label: {
            color: '#ffffff',
            formatter: `${options.yData[yLen - 1]}`,
            position: 'inside',
            align: 'center',
            verticalAlign: 'middle',
          },
          itemStyle: {
            color: '#000000',
            opacity: 0.6,
          },
          data: [
            {
              name: '最大值',
              type: 'max',
              valueDim: 'x',
            },
          ],
        },
      },
    ],
    grid: {
      left: 40,
      top: 30,
      right: 15,
      bottom: 20,
    },
  };
  return defaultOption;
};

const getNatStatusOption = (options, type) => {
  if (!options.yData) return {};
  const yLen = options.yData.length;
  const defaultOption = {
    visualMap: [
      {
        show: false,
        type: 'continuous',
        seriesIndex: 0,
        min: 0,
        max: 7,
        inRange: {
          color: ['#D4A764', '#ECD09A'],
        },
      },
    ],
    xAxis: {
      type: 'category',
      axisTick: {
        show: false,
        alignWithLabel: true,
      },
      axisLine: { show: false },
      axisLabel: {
        color: '#999999',
        showMaxLabel: true,
        interval: type === 'natType' ? 0 : 'auto',
      },
      data: options.xData,
    },
    yAxis: {
      type: 'value',
      name: options.yTitle,
      min: 0,
      max: 7,
      nameTextStyle: {
        color: '#999999',
        align: 'right',
      },
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: {
        lineStyle: { color: '#ececec' },
      },
      axisLabel: {
        formatter: function(value, index) {
          return `${NAT_MAP[value]}`;
        },
        color: '#999999',
      },
    },
    series: [
      {
        data: options.yData,
        type: 'line',
        symbol: 'none',
        markPoint: {
          silent: true,
          symbol: 'rect',
          symbolSize: [50, 20],
          symbolOffset: ['-15%', 0],
          label: {
            color: '#ffffff',
            formatter: `${NAT_MAP[options.yData[yLen - 1]]}`,
            position: 'inside',
            align: 'center',
            verticalAlign: 'middle',
          },
          itemStyle: {
            color: '#000000',
            opacity: 0.6,
          },
          data: [
            {
              name: '最大值',
              type: 'max',
              valueDim: 'x',
            },
          ],
        },
      },
    ],
    grid: {
      left: 50,
      top: 30,
      right: 15,
      bottom: 20,
    },
  };
  return defaultOption;
};

const getOnlineTimeOption = options => {
  const defaultOption = {
    xAxis: {
      type: 'category',
      axisTick: {
        show: false,
        alignWithLabel: true,
      },
      axisLine: { show: false },
      axisLabel: {
        color: '#999999',
        interval: 0,
        showMaxLabel: true,
      },
      data: options.xData,
    },
    yAxis: {
      type: 'value',
      max: 24,
      min: 0,
      name: '时间(h)',
      nameTextStyle: {
        color: '#999999',
      },
      minInterval: 6,
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: {
        lineStyle: { color: '#ececec' },
      },
      axisLabel: {
        color: '#999999',
      },
    },
    series: [
      {
        data: options.yData,
        type: 'bar',
        barWidth: 8,
        itemStyle: {
          normal: {
            barBorderRadius: [10, 10, 0, 0],
            color: '#dbb378',
          },
        },
        // markLine: {
        //   silent: true,
        //   symbol: ['none', 'none'],
        //   lineStyle: { color: '#A1602B', type: 'dotted' },
        //   animation: false,
        //   data: [
        //     {
        //       name: '标准',
        //       yAxis: 16,
        //       label: {
        //         position: 'insideEndBottom',
        //         formatter: '标准',
        //       },
        //     },
        //   ],
        // },
      },
    ],
    grid: {
      left: 25,
      top: 30,
      right: 10,
      bottom: 20,
    },
  };
  return defaultOption;
};

export default function getChartOptions(type = 'online', options) {
  let chartOption = {};
  switch (type) {
    case 'online':
      chartOption = getOnlineChartOption(options);
      break;
    case DEVICE_PING_LOST_INDICATOR:
    case DEVICE_PING_RTT_INDICATOR:
    case 'pingLostAvg':
    case 'pingLost':
    case 'pingRttAvg':
    case 'pingRtt':
      chartOption = getPingLostOption(options);
      break;
    case 'nat':
    case 'natType':
      chartOption = getNatStatusOption(options, type);
      break;
    case 'cpu':
    case 'mem':
      chartOption = getCpuOption(options);
      break;
    case 'onlineTime':
    case DEVICE_ONLINE_TIME_INDICATOR:
      chartOption = getOnlineTimeOption(options);
      break;
    default:
      chartOption = {};
      break;
  }
  return chartOption;
}
